<template>
  <Base/>
</template>
<script>
import Base from 'operations/knowledgeBase/base.vue'
export default {
    components:{
      Base
    }
}
</script>